import { Button, message, Space } from "antd";
import moment from "moment";
import customFetch from "./apicall/api";
import { queueService } from "../services/QueueService";
import { cleanupFirebaseListeners } from "../firebase";

export function logout(otherscreen = null, no_of_page = null, isUserLogout = false) {
  //const formdata = new FormData();
  // console.log(api_token);
  
  // Broadcast logout event to all tabs to terminate all sessions
  localStorage.setItem("SESSION_LOGOUT_BROADCAST", new Date().getTime().toString());
  
  let api_token = localStorage.getItem("api_token");
  console.log("api_token", api_token);
  
  // Build request options
  const requestOptions = {
    method: "POST",
    headers: { 
      "api-token": api_token,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ userLogout: isUserLogout })
  };
  
  customFetch(process.env.REACT_APP_URL + "/new/logout", requestOptions)
    .then((res) => {
      return res.json();
    })    .then((data) => {
      // console.log(data);
      
      // Stop queue processing on logout
      queueService.stopProcessing();
      
      // Clean up Firebase listeners to prevent memory leaks
      cleanupFirebaseListeners();
      
      if (otherscreen != null) {
        if (no_of_page != null) {
          localStorage.clear();
          window.history.go("-" + no_of_page);
        } else {
          localStorage.clear();
          window.history.back();
        }
      } else {
        localStorage.clear();
        window.location.href = "/";
      }
    })    .catch((error) => {
      console.log(error);
      
      // Stop queue processing even on logout error
      queueService.stopProcessing();
      
      // Clean up Firebase listeners even on logout error
      cleanupFirebaseListeners();
      
      // Clear localStorage even on logout error to ensure all tabs sync
      localStorage.clear();
    });
}

// export function netspeed() {
//   return navigator.connection.downlink > 1
//     ? navigator.connection.downlink + " Mb/s"
//     : navigator.connection.downlink + " Kb/s";
// }

var beforeload = new Date().getTime();
var ms;
export function navtime() {
  // let totime = 0;
  // totime = performance.now().toFixed(0) + " ms";
  // console.log("Nav Time:", performance.now());
  // return totime;
  // console.log("beforeload:", beforeload);
  var afterload = new Date().getTime();
  ms = afterload - beforeload;
  beforeload = new Date().getTime();
  return ms + " ms";
}
// export function navtime() {
//   let data;

//   describe("navigation", () => {
//     beforeAll(async () => {
//       data = await navigation();
//     });
//     [
//       "connect_end",
//       "connect_start",
//       "decoded_body_size",
//       "domain_lookup_end",
//       "domain_lookup_start",
//       "dom_complete",
//       "dom_content_loaded_event_end",
//       "dom_content_loaded_event_start",
//       "dom_interactive",
//       "duration",
//       "encoded_body_size",
//       "fetch_start",
//       "load_event_end",
//       "load_event_start",
//       "redirect_end",
//       "redirect_start",
//       "request_start",
//       "response_end",
//       "response_start",
//       "secure_connection_start",
//       "transfer_size",
//       "unload_event_end",
//       "unload_event_start",
//       "worker_start",
//     ].forEach((event) =>
//       it(`${event} == number`, () => {
//         expect(data).to.have.property(event);
//         expect(data[event]).to.be.a("number");
//       })
//     );
//     ["dom_loading", "navigation_start"].forEach((event) =>
//       it(`${event} == undefined`, () => {
//         expect(data).to.have.property(event);
//         expect(data[event]).to.be.a("undefined");
//       })
//     );
//   });
//   //console.log("Navigation:", data);
//   //return data;
// }

const buildFilter = (filter) => {
  let query = {};
  for (let keys in filter) {
    if (
      filter[keys].constructor === Object ||
      (filter[keys].constructor === Array && filter[keys].length > 0)
    ) {
      query[keys] = filter[keys];
    }
  }
  return query;
};

export function generateId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

// Our new filter function
export const filterData = (data, query, keysWithMinMax = []) => {
  //let truth_value;
  query = buildFilter(query);
  const filteredData = data.filter((item) => {
    for (let key in query) {
      if (item[key] === undefined) {
        return false;
      } else if (keysWithMinMax.includes(key)) {
        let truth_value = query[key].some((range) => {
          if (
            (range["min"] !== null && item[key] < range["min"]) ||
            (range["max"] !== null && item[key] > range["max"])
          ) {
            return false;
          } else {
            return true;
          }
        });
        if (truth_value == false) return truth_value;
      } else if (
        !query[key].some((value) => String(item[key]).includes(value))
      ) {
        return false;
      }
    }
    return true;
  });
  return filteredData;
};

// query = buildFilter(filter);
// console.log(JSON.stringify(query));
// result = filterData(data, query);
// console.log(JSON.stringify(result, null, 4))

// filter = {
//   type: [
//       'Apartment',
//   ],
//   saleType: [
//       'For Rent',
//   ],
//  listPrice: [
//   {min: null,
//     max: 1}
//  ],
//   washerDryerInUnit: [
//       true,
//   ],
// };

// Check API input are null or not if null then logout
export function chkapiinput(arr) {
  for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    // console.log("aaaa", arr[index]);
    if (arr[index] === null || arr[index] === "") {
      Popup();
      return false;
      break;
    }
  }
}
export function Popup() {
  message.open({
    type: "error",
    content: "You are Logout. Login again",
    className: "custom-class",
    duration: 10,
    style: {
      marginTop: "20vh",
    },
  });
}

export function setDateTime(date, str) {
  var sp = str.split(":");
  date.setHours(parseInt(sp[0], 10));
  date.setMinutes(parseInt(sp[1], 10));
  date.setSeconds(parseInt(sp[2], 10));
  return date;
}
export function checkTime() {
  var d = new Date();
  let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
  let mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
  var current, currentend;
  var mainstime = moment(
    process.env.REACT_APP_MAINTENANCE_START,
    "DD/MM/YYYY HH:mm:ss"
  ).format("YYYY-MM-DD HH:mm:ss");
  var mainendtime = moment(
    process.env.REACT_APP_MAINTENANCE_END,
    "DD/MM/YYYY HH:mm:ss"
  ).format("YYYY-MM-DD HH:mm:ss");

  // if (moment("01/" + mo + "/" + ye).format("ddd") === "Fri") {
  //   current = new Date("01/" + mo + "/" + ye);
  //   startTime = setDateTime(new Date(current), "18:00:00");
  //   //currentend = new Date("02/" + mo + "/" + ye);
  //   currentend = new Date("02/" + mo + "/" + ye);
  //   endTime = setDateTime(new Date(currentend), "2:00:00");
  // } else {
  //   current = new Date("02/" + mo + "/" + ye);
  //   startTime = setDateTime(new Date(current), "21:00:00");
  //   //currentend = new Date("03/" + mo + "/" + ye);
  //   currentend = new Date("03/" + mo + "/" + ye);
  //   endTime = setDateTime(new Date(currentend), "2:00:00");
  // }

  var startTime = new Date(mainstime);
  var endTime = new Date(mainendtime);
  if (d > startTime.getTime() && d < endTime.getTime()) {
    // this.state.time_flag = 1;
    // this.setState({ isSpin: false });
    //alert("y");

    var stime = moment(mainstime).format("hh a");
    var etime = moment(mainendtime).format("hh a");
    var message =
      "This facility will not be available between " + stime + " to " + etime;
    return message;
  } else {
    //alert("N");
    //this.state.time_flag = 0;
    return false;
  }
}
export function checkBanner() {
  var mainsdate = moment(
    process.env.REACT_APP_MAINTENANCE_START,
    "DD/MM/YYYY"
  ).format("YYYY-MM-DD HH:mm:ss");
  var mainstime = moment(
    process.env.REACT_APP_MAINTENANCE_START,
    "DD/MM/YYYY HH:mm:ss"
  ).format("YYYY-MM-DD HH:mm:ss");
  var mainendtime = moment(
    process.env.REACT_APP_MAINTENANCE_END,
    "DD/MM/YYYY HH:mm:ss"
  ).format("YYYY-MM-DD HH:mm:ss");
  //return mainsdate;
  // if (!moment().isAfter(mainsdate)) {
  //   alert("future");
  // }
  if (
    moment(mainsdate).isSame(moment(), "day") == true ||
    !moment().isAfter(mainsdate)
  ) {
    var stime = moment(mainstime).format("dddd hh:mm a");
    var etime = moment(mainendtime).format("dddd hh:mm a");

    var message =
      stime +
      " से " +
      etime +
      " तक कलेक्शन ऐप डाउन रहेगा. आप कलेक्शन की एंट्री नहीं कर पायेंगे.";
    return message;
  } else {
    return false;
  }
}

export function bannertimer() {
  var mainsdate = moment(
    process.env.REACT_APP_MAINTENANCE_START,
    "DD/MM/YYYY HH:mm:ss"
  ).format("YYYY-MM-DD HH:mm:ss");
  var now = new Date().getTime();
  var t = moment(mainsdate).valueOf() - moment().valueOf();
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  var hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((t % (1000 * 60)) / 1000);
  //this.setState({days, minutes, hours, seconds})
  if (t < 0) {
    clearInterval(this.x);
    //this.setState({ days: 0, minutes: 0, hours: 0, seconds: 0, time_up: "TIME IS UP" })
  }
  return (
    days +
    " Day, " +
    hours +
    " Hours, " +
    minutes +
    " Minutes, " +
    seconds +
    " Seconds"
  );
}

// consolidate data for report
// const options = ['zone_id','division_id','cluster_name','branch_id'];
export function consolidate(basedata, option) {
  let indexedData = {};
  if (option != "") {
    basedata.forEach((row) => {
      let index = row[option];
      if (indexedData[index]) {
        let previousValue = indexedData[index];
        indexedData[index] = {
          ...previousValue,
          collected: previousValue["collected"] + row["collected"],
          deposited: previousValue["deposited"] + row["deposited"],
          opening_balance:
            previousValue["opening_balance"] + row["opening_balance"],
          closing_balance:
            previousValue["closing_balance"] + row["closing_balance"],
          fcm_approval_pending:
            previousValue["fcm_approval_pending"] + row["fcm_approval_pending"],
          finops_approval_pending:
            previousValue["finops_approval_pending"] +
            row["finops_approval_pending"],
          fcm_approved_amount:
            previousValue["fcm_approved_amount"] + row["fcm_approved_amount"],
        };
      } else {
        indexedData[index] = {
          ...row,
          zone_id: 0,
          zone: "",
          division_id: 0,
          division: "",
          cluster_name: "",
          branch_code: "",
          branch_id: 0,
          branch_name: "",
          product_group_name: "All",
          state_name: "All",
          id: 424,
          userid: 0,
          username: "",
          usertype: "All",
        };
      }
      if (option == "branch_id") {
        indexedData[index]["branch_id"] = row["branch_id"];
        indexedData[index]["branch_name"] = row["branch_name"];
        indexedData[index]["branch_code"] = row["branch_code"];
        indexedData[index]["cluster_name"] = row["cluster_name"];
        indexedData[index]["division_id"] = row["division_id"];
        indexedData[index]["division"] = row["division"];
        indexedData[index]["zone_id"] = row["zone_id"];
        indexedData[index]["zone"] = row["zone"];
      }
      if (option == "zone_id") {
        indexedData[index]["zone_id"] = row["zone_id"];
        indexedData[index]["zone"] = row["zone"];
      }
      if (option == "division_id") {
        indexedData[index]["division_id"] = row["division_id"];
        indexedData[index]["division"] = row["division"];
        indexedData[index]["zone_id"] = row["zone_id"];
        indexedData[index]["zone"] = row["zone"];
      }
      if (option == "cluster_name") {
        indexedData[index]["cluster_name"] = row["cluster_name"];
        indexedData[index]["division_id"] = row["division_id"];
        indexedData[index]["division"] = row["division"];
        indexedData[index]["zone_id"] = row["zone_id"];
        indexedData[index]["zone"] = row["zone"];
      }
    });
    return Object.values(indexedData);
  } else {
    return basedata;
  }
}

const generateValueFromRegex = (regexPattern) => {
  if (!regexPattern || typeof regexPattern !== "string") return "";

  try {
    const RandExp = require("randexp").default || require("randexp");
    const randexp = new RandExp(regexPattern);
    randexp.defaultRange.add(0, 65535);
    return randexp.gen();
  } catch (error) {
    console.error("Invalid regex pattern:", regexPattern, error);
    return "";
  }
};
const computeHash = async (data) => {
  const encoder = new TextEncoder();
  const jsonString = JSON.stringify(data);
  const dataBytes = encoder.encode(jsonString);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBytes);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const generate_dynamic_id = async (autogeneratetxn, convertedData) => {
  const res = await Promise.all(autogeneratetxn.map(async (autogenConfig) => {
    let txn_ref_no = "";

    if (["transaction_no", "random"].includes(autogenConfig.selectConfig)) {
      const regex = autogenConfig.regularExpression || ".*";
      console.log("Using regularExpression:", regex);
      txn_ref_no = generateValueFromRegex(regex);
      if (autogenConfig.isappendtxn === "1") {
        txn_ref_no = `${convertedData[autogenConfig.BucketField]}||${txn_ref_no}`;
      }
    } else if (autogenConfig.selectConfig === "date_time") {
      const dateTimeFormat = autogenConfig.dateTimeFormat;
      const currentDateTime = (() => {
        switch (dateTimeFormat) {
          case "iso":
            return new Date().toISOString();
          case "us":
            return new Date().toLocaleString("en-US");
          case "intl":
            return new Date().toLocaleString("en-GB");
          case "unix":
            return Math.floor(Date.now() / 1000);
          case "rfc2822":
            return new Date().toUTCString();
          case "custom":
            return new Date().toLocaleString("en-IN", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
          default:
            return new Date().toISOString();
        }
      })();
      txn_ref_no = autogenConfig.isappendtxn === "1"
        ? `${convertedData[autogenConfig.BucketField]}||${currentDateTime}`
        : currentDateTime;
    } else if (autogenConfig.selectConfig === "user_id") {
      const userId = localStorage.getItem("in_userid");
      txn_ref_no = autogenConfig.isappendtxn === "1"
        ? `${convertedData[autogenConfig.BucketField]}||${userId}`
        : userId;
    } else if (autogenConfig.selectConfig === "reusable") {
      txn_ref_no = await computeHash(convertedData);
    }

    return {
      key: [autogenConfig.BucketField],
      value: txn_ref_no
    };
  }));

  return res;
};

export function buildApiPayload(API, dataSource, config, upd_data, apiState = []) {
  const payload = {};
  
  config && config.forEach((field) => {
    if (field.api_endpoints.includes(API)) {
      const key = field.key;
      const flag = field.flag;
      const value = field.value;
      const conditions = field.rules;
      
      let merged_data;
      const updateArray = Array.isArray(upd_data) ? upd_data : upd_data ? [upd_data] : [];
      const dataArray = Array.isArray(dataSource) ? dataSource : dataSource ? [dataSource] : [];
      const apiStateArray = Array.isArray(apiState) ? apiState : apiState ? [apiState] : [];
      if (field.get_from_api == true) {
        merged_data = [
          {
            ...(updateArray.length > 0 ? updateArray[0] : {}),
            ...(dataArray.length > 0 ? dataArray[0] : {}),
            ...(apiStateArray.length > 0 ? apiStateArray[0] : {}),
          },
        ]
      } else {
        if (field.use_old_data) {
          merged_data = [
            {
              ...(updateArray.length > 0 ? updateArray[0] : {}),
              ...(dataArray.length > 0 ? dataArray[0] : {}),
            },
          ];
        } else {
          
          merged_data = [
            {
              ...(dataArray.length > 0 ? dataArray[0] : {}),
              ...(updateArray.length > 0 ? updateArray[0] : {}),
            },
          ];
        }
      }
      if (Array.isArray(conditions) && conditions.length > 0 && !compareDataWithConfig(merged_data, conditions)) {
        console.log(`Skipping field ${key}: conditions not satisfied`);
        return; // skip this field
      }

      let finalValue;

      if (flag === "S") {
        finalValue = value;
      } else if (flag === "D") {
        if (value === "date_time") {
          const now = moment();
          finalValue = now.unix();
        } else if (value === "transaction_no") {
          if (field.regularExpression) {
            finalValue = generateRegexValue(field.regularExpression);
          } else {
            finalValue = null;
          }
        } else if (value === "logged_in_user") {
          finalValue = parseInt(localStorage.getItem("in_userid"));
        } else if (value === "logged_in_username") {
          finalValue = localStorage.getItem("in_username");
        } else if (value === "logged_in_employee_name") {
          finalValue = localStorage.getItem("employee_name");
        } else {
          finalValue = getValueFromPath(merged_data[0], value);
        }
        console.log("Dynamic Value:", key, finalValue);
      }

      if (key) {
        setValueByPath(payload, key, finalValue);
      }
    }
  });
  
  console.log("Final Payload:", payload);
  return payload;
}

export function generateRegexValue(regexPattern) {
  try {
    const pattern = regexPattern;
    let result = '';
    let i = 0;

    while (i < pattern.length) {
      if (pattern[i] === '[') {
        const endBracket = pattern.indexOf(']', i);
        if (endBracket === -1) {
          result += pattern[i];
          i++;
          continue;
        }

        const charClass = pattern.substring(i + 1, endBracket);
        let quantifierStart = endBracket + 1;
        let quantifier = '1';

        if (quantifierStart < pattern.length && pattern[quantifierStart] === '{') {
          const endBrace = pattern.indexOf('}', quantifierStart);
          if (endBrace !== -1) {
            quantifier = pattern.substring(quantifierStart + 1, endBrace);
            quantifierStart = endBrace + 1;
          }
        }

        const [min, max] = parseQuantifier(quantifier);
        const count = getRandomCount(min, max);
        const possibleChars = expandCharacterClass(charClass);

        for (let j = 0; j < count; j++) {
          result += possibleChars[Math.floor(Math.random() * possibleChars.length)];
        }

        i = quantifierStart;
      } else {
        result += pattern[i];
        i++;
      }
    }

    return result;
  } catch (error) {
    console.error('Error generating regex value:', error);
    return null;
  }
}

function parseQuantifier(quantifier) {
  if (quantifier.includes(',')) {
    const parts = quantifier.split(',');
    const min = parseInt(parts[0]) || 0;
    const max = parseInt(parts[1]) || min;
    return [min, max];
  } else {
    const count = parseInt(quantifier) || 1;
    return [count, count];
  }
}

function getRandomCount(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function expandCharacterClass(charClass) {
  let result = '';
  let i = 0;

  while (i < charClass.length) {
    if (i + 2 < charClass.length && charClass[i + 1] === '-') {
      const startChar = charClass[i];
      const endChar = charClass[i + 2];
      
      if (startChar <= endChar) {
        const startCode = startChar.charCodeAt(0);
        const endCode = endChar.charCodeAt(0);
        
        for (let code = startCode; code <= endCode; code++) {
          result += String.fromCharCode(code);
        }
      }
      i += 3;
    } else {
      result += charClass[i];
      i++;
    }
  }

  return result;
}

export function getValueFromPath(obj, path) {
  try {
    return path
      .replace(/\[(\d+)\]/g, ".$1")
      .replace(/:/g, ".")
      .split(".")
      .reduce((acc, part) => acc && acc[part], obj);
  } catch {
    return null;
  }
}

export function setValueByPath(obj, path, value) {
  if (!path || typeof path !== 'string') {
    return;
  }

  if (path.endsWith("[]")) {
    const key = path.replace("[]", "");
    if (!obj[key]) obj[key] = [];
    obj[key].push(value);
    return;
  }

  const keys = path.replace(/\[(\d+)\]/g, ".$1").split(".");
  let current = obj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      if (!current[key]) current[key] = isNaN(keys[index + 1]) ? {} : [];
      current = current[key];
    }
  });
}

export function applyAtomicAndAggregationRules(upd_data, payload_config) {
  let transformed_data = {};

  if (upd_data && upd_data.length > 0) {
    const { object_id, linked_movement_id, transactions, ...rest } = upd_data[0];

    // If flag is set, use the provided transactions array from each upd_data entry
    if (payload_config.useOldTransactionsArray) {
      const seen = new Set();
      const uniqueTransactions = [];

      // Loop through each upd_data item
      for (let i = 0; i < upd_data.length; i++) {
        const item = upd_data[i];

        // Loop through the transactions array for each item in upd_data
        for (let j = 0; j < item.transactions.length; j++) {
          const transaction = item.transactions[j];

          // Construct the key from previous_transaction_id and aggregation_id
          const key = `${transaction.previous_transaction_id}_${transaction.aggregation_id || item.object_id}`;

          if (!seen.has(key)) {
            seen.add(key);
            uniqueTransactions.push({
              previous_transaction_id: item.object_id,
              aggregation_id: transaction.aggregation_id,
            });
          }
        }
      }

      transformed_data = {
        ...rest,
        transactions: uniqueTransactions,
      };
    } else {
      // Original logic if the flag is not set
      const seen = new Set();
      const uniqueTransactions = upd_data
        .map((item) => ({
          previous_transaction_id: item.linked_movement_id,
          aggregation_id: item.object_id,
        }))
        .filter((transaction) => {
          const key = `${transaction.previous_transaction_id}_${transaction.aggregation_id}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });

      transformed_data = {
        ...rest,
        transactions: uniqueTransactions,
      };
    }
  }

  transformed_data["processed"] = false;

  if (payload_config.isAtomic && payload_config.isAtomic === "true") {
    transformed_data["isAtomic"] = true;
    const temp_status = transformed_data["status"];
    transformed_data["destination_status"] = temp_status;
    transformed_data["status"] = transformed_data["current_status"];
    delete transformed_data["current_status"];
  } else {
    transformed_data["isAtomic"] = false;

    if (
      payload_config.isAggregation &&
      payload_config.isAggregation === "true" &&
      payload_config.aggregation_db &&
      payload_config.aggregation_collection
    ) {
      transformed_data["db_name"] = payload_config.aggregation_db;
      transformed_data["collection_name"] = payload_config.aggregation_collection;
      const temp_status = transformed_data["status"];
      transformed_data["destination_status"] = temp_status;
      transformed_data["status"] = transformed_data["current_status"];
      delete transformed_data["current_status"];
    } else {
      delete transformed_data["current_status"];
    }
  }

  return transformed_data;
}

export function compareDataWithConfig(data, config) {
  const evaluateCondition = (record, condition) => {
    const { field, operator, value } = condition;
    const recordVal = getValueFromPath(record, field);

    switch (operator) {
      case '==': return recordVal == value;
      case '===': return recordVal === value;
      case '!=': return recordVal != value;
      case '!==': return recordVal !== value;
      case '>': return recordVal > value;
      case '<': return recordVal < value;
      case '>=': return recordVal >= value;
      case '<=': return recordVal <= value;
      case 'includes':
        if (Array.isArray(recordVal)) return recordVal.includes(value);
        if (typeof recordVal === 'string') return recordVal.includes(value);
        return false;
      case 'startsWith': return typeof recordVal === 'string' && recordVal.startsWith(value);
      case 'endsWith': return typeof recordVal === 'string' && recordVal.endsWith(value);
      default: throw new Error(`Unknown operator: ${operator}`);
    }
  };

  const evaluateGroup = (record, group) => {
    if (group.type === 'condition') return evaluateCondition(record, group);
    if (group.type === 'AND') return group.conditions.every(cond => evaluateGroup(record, cond));
    if (group.type === 'OR') return group.conditions.some(cond => evaluateGroup(record, cond));
    throw new Error(`Unknown group type: ${group.type}`);
  };

  
  return data.some(record => config.some(group => evaluateGroup(record, group)));
}
